import { AbstractProgram } from "@kvix/shared";
import { makeStyles } from "@material-ui/core";
import React from "react";

interface Props {
  program: AbstractProgram;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    paddingBottom: "56.25%",
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  ratio: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    display: "flex",
    alignItems: "center",
  },
  poster: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
}));

export const ProgramPoster: React.FC<Props> = (props) => {
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <div className={classes.ratio}>
        <img
          alt={props.program?.title ? props.program.title : ""}
          className={classes.poster}
          src={props.program.posterUrl}
        />
      </div>
    </div>
  );
};
